import React from 'react';
import PropTypes from 'prop-types';
import createWidget from '../createWidget';
import { AreaChartComponent_v2 as AreaChartComponent } from '../../AreaChartComponent_v2.js';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

/**
 * AreaChartInner - Inner component for the area chart widget
 * Renders the actual area chart visualization
 */
const noop = () => {};
const AreaChartInner = ({ data, config, filters, onFilterAdd, isEditMode }) => {
  // Handle filter add events from chart interactions
  const handleFilterAdd = (filter) => {
    if (onFilterAdd) {
      onFilterAdd(filter);
    }
  };

  return (
    <AreaChartComponent
      data={data.data}
      title={config.title}
      dateFormat={config.dateFormat}
      legendPosition={config.legendPosition}
      dateGrouping={config.dateGrouping}
      showButtons={config.showButtons}
      stacked={config.stacked}
      filters={filters}
      setFilters={noop} // Handled by parent
      addFilter={handleFilterAdd}
      token={null} // Will be handled by the hook
      currentGrouping={config.currentGrouping}
      height="100%"
      useOwnBackground={!isEditMode}
    />
  );
};

AreaChartInner.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.array.isRequired
  }).isRequired,
  config: PropTypes.shape({
    title: PropTypes.string.isRequired,
    dateFormat: PropTypes.string,
    stacked: PropTypes.bool,
    showButtons: PropTypes.bool,
    legendPosition: PropTypes.oneOf(['bottom', 'right', 'top', 'left']),
    dateGrouping: PropTypes.object,
    currentGrouping: PropTypes.object
  }).isRequired,
  filters: PropTypes.array,
  onFilterAdd: PropTypes.func,
  isEditMode: PropTypes.bool
};

/**
 * AreaChartWidget - Created using the widget factory
 * Displays time-series data as an area chart
 */
const AreaChartWidget = createWidget('areachart', AreaChartInner, {
  includeDates: false, // AreaChart handles dates differently via dateGrouping
  containerClassName: "h-full flex flex-col",
  containerStyle: { minHeight: '200px', height: '100%' },
  emptyState: {
    title: 'No chart data available',
    description: 'Try adjusting your filters or date range',
    icon: icon({ name: 'chart-area', family: 'sharp', style: 'light' })
  }
});

export default AreaChartWidget;
